import React from "react";
import ClientFooter from "./ClientFooter";
import { Bold } from "lucide-react";

const TermsAndConditions = () => {
    return (
        <>
            <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner text-center">
                                <h2 className="title">Terms and Conditions</h2>
                                <ul className="page-list">
                                    <li className="rbt-breadcrumb-item">
                                        <a href="index.html">Home</a>
                                    </li>
                                    <li>
                                        <div className="icon-right">
                                            <i className="feather-chevron-right" />
                                        </div>
                                    </li>
                                    <li className="rbt-breadcrumb-item active">Terms and Conditions</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rbt-overlay-page-wrapper">
                <div className="rbt-putchase-guide-area breadcrumb-style-max-width rbt-section-gapBottom">
                    <div className="rbt-article-content-wrapper">
                        <div className="content mt-5">
                          <h4>Terms and Conditions – Day Trading Tactics
                          </h4>

                            <p className="mb-4">
                                Welcome to <b>Day Trading Tactics!</b> By accessing or using our website and enrolling in any of our courses, you agree to the following Terms and Conditions. Please read them carefully.
                            </p>

                            <h4>1. Acceptance of Terms</h4>
                            <p>
                                By purchasing or accessing our content, you agree to these Terms and Conditions, Privacy Policy, Refund Policy, and Trading Disclaimer.
                            </p>

                            <h4>2. Course Access</h4>
                            <ul>
                                <li>Course access is valid for <b>6 months</b> from the date of purchase.</li>
                                <li>Live market support and mentorship access are available for <b>1 month</b>.</li>
                                <li>Each purchase grants access to one individual only. Sharing login credentials is prohibited.</li>
                            </ul>

                            <h4>3. Intellectual Property</h4>
                            <p>All videos, PDFs, strategies, and live session recordings are copyrighted under Indian Law.</p>
                            <ul>
                                <li>You may not record, reproduce, distribute, sell, or repost course content.</li>
                                <li>Any unauthorized sharing will result in immediate access revocation and legal action.</li>
                            </ul>

                            <h4>4. Payment & Refunds</h4>
                            <ul>
                                <li>Payments are processed securely via Razorpay.</li>
                                <li><b>No refunds</b> will be provided once a course is purchased.</li>
                                <li><b>Live Market Session Add-On:</b> If you purchase an add-on pack for extended live market session access, please note that <b>no refunds</b> will be provided for the add-on purchase under any circumstances.</li>
                            </ul>

                            <h4>5. User Conduct</h4>
                            <ul>
                                <li>Be respectful in community forums and live sessions.</li>
                                <li>Do not engage in spam, promotions, or offensive content.</li>
                            </ul>

                            <h4>6. Limitation of Liability</h4>
                            <ul>
                                <li>All content, courses, and services provided by Day Trading Tactics are strictly for educational and informational purposes only. Trading in financial markets involves significant risk, and past performance does not guarantee future results.</li>
                                <li>We do not provide any guarantees of profit or success, and we are not responsible or liable for any financial loss, damage, or consequences incurred while using our content, strategies, or tools.</li>
                                <li>Users are solely responsible for their trading or investment decisions. It is strongly advised to consult with a SEBI-registered financial advisor before executing any trades based on our teachings or recommendations.</li>
                            </ul>

                            <h4>7. Account Suspension</h4>
                            <p>We reserve the right to suspend access for any student found violating these terms, leaking content, or misusing the platform.</p>

                            <h4>8. Terms and Conditions – Course Access</h4>
                            <p>To maintain the integrity of our community and ensure a secure learning environment, we have the following mandatory requirements for all participants:</p>

                            <h5>8.1 Minimum Capital Requirement</h5>
                            <ul>
                                <li>To apply the strategies taught in this course effectively, a minimum trading capital of ₹1.5 to ₹2 lakhs is compulsory. This ensures proper risk management on each trade, especially in current market conditions with increased lot sizes.</li>
                                <li>For Learning-Only Participants: If you are enrolling only to learn the concepts and do not intend to trade immediately, you are welcome to join the course without meeting the capital requirement. You can pay the course fee and gain full access to all educational content.</li>
                                <li>For Active Traders: If you plan to trade based on the strategies taught in this course, having the minimum required capital is mandatory. This helps you implement the learnings effectively while maintaining disciplined risk management.</li>
                            </ul>

                            <h5>8.2 WhatsApp Number Submission</h5>
                            <ul>
                                <li>It is mandatory to provide your active WhatsApp number during the registration process.</li>
                                <li>This is required to add you to our exclusive mentorship/support groups and to share important updates or resources related to the course.</li>
                            </ul>

                            <h5>8.3 Live Profile Picture</h5>
                            <ul>
                                <li>You must upload or use a real-time (live) profile picture of yourself on Profile.</li>
                                <li>This helps us verify your identity and ensures genuine interactions within Day Trading Tactics.</li>
                            </ul>

                            <p className="mb-4"><em>Note: Access to the course and associated mentorship will only be granted once these steps are completed. By registering, you agree to abide by these terms to help maintain a secure and authentic learning environment for all participants.</em></p>

                            <h5>8.4 Market Volatility Disclaimer</h5>
                            <p>The financial markets are dynamic and subject to sudden changes. All strategies, concepts, and methods taught through Day Trading Tactics are designed based on the current market conditions at the time of teaching. These strategies may not yield the same results if market behavior changes in the future.</p>

                            <h5>8.5 Strategy Updates and Market Adaptation</h5>
                            <p>As market patterns evolve, it is essential to adapt trading strategies accordingly. We continuously analyze and back test to ensure effectiveness. Therefore, strategies may be modified, replaced, or upgraded over time to stay aligned with the market.</p>

                            <h5>8.6 Access to Future Strategies</h5>
                            <p>Students enrolled in our programs are granted access only to the strategies taught during their period of enrollment. If a new or revised strategy is introduced after one or more years, access to that material will require a separate payment. Previous enrollment does not entitle students to complimentary access to future strategies.</p>

                            <h5>8.7 Continuous Learning is Essential</h5>
                            <p>Due to the ever-changing nature of the markets, traders are encouraged to stay updated, continue learning, and adapt to new methods as needed. Our goal is to provide timely and relevant trading education based on current conditions.</p>

                            <h5>8.8 No Performance Guarantee</h5>
                            <p>While we aim to equip students with the best possible tools and knowledge, we do not guarantee specific results or profits. All trading involves risk, and past performance of any strategy does not ensure future success.</p>

                            <h4>9. Updates to Terms</h4>
                            <p>We may revise these Terms at any time. Continued use of the platform after updates implies acceptance.</p>
                        </div>
                    </div>
                </div>
            </div>
            <ClientFooter/>
        </>
    );
};

export default TermsAndConditions; 